export const getSignupProps = state => {
    return {
        first_name: state.props.first_name,
        last_name: state.props.last_name,
        brand_name: state.props.brand_name,
        country_id: state.props.country_id,
        email_address: state.props.email_address,
        tailoring_category: state.props.tailoring_category
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/signup/getters.js